import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

const Iframe = styled('iframe')`
  height: 300px; 
  width: 650px;
`;

export default function GoogleMap(props) {
  return (
    getMap(props.queryString)
  );
}

function getUrl(queryString) {
  const API_KEY = 'AIzaSyAt2IHTbw4NyNEgMtKKy02ZhdT5BLH25rY';
  return `https://www.google.com/maps/embed/v1/place?key=${API_KEY}&q=${queryString}`
}

function getMap(queryString) {
  return queryString ? getIframe(queryString) : null;
}

function getIframe(queryString) {
  return <Iframe src={getUrl(queryString)} frameBorder="0" />;
}

GoogleMap.propTypes = {
  queryString: PropTypes.string,
};
GoogleMap.defaultProps = {
  queryString: '',
};



// WEBPACK FOOTER //
// ./src/components/GoogleMap/GoogleMap.js